import type { useLayoutStore } from "@/store/layoutStore";
import type { NavNode } from "@/utils/navUtils";

// Recursively filter nav tree nodes (settings, account) for favorites
export function filterNavTreeForFavorites(
  node: NavNode | null,
  layoutStore: ReturnType<typeof useLayoutStore>,
): NavNode | null {
  if (!node) return null;
  const isFavorite = layoutStore.isFavorite(node.layoutStoreKey ?? "");

  if (isFavorite) {
    return { ...node, favorite: true };
  }

  const filteredChildren: NavNode[] = node.children
    ? node.children
        .map((child) => filterNavTreeForFavorites(child, layoutStore))
        .filter((child): child is NavNode => child !== null)
    : [];

  if (filteredChildren.length > 0) {
    return {
      ...node,
      children: filteredChildren,
      favorite: false,
    };
  }

  return null;
}
